import { useStyletron } from 'styletron-react';
import _get from 'lodash/get';

import { GLOBAL_THEME, StyleOverrideFunctionPropsT } from 'commons-ui';

import { VIEW_FIELD_KEYS, KYC_STATUS_VALUE, KYC_STATUS_VALUE_COLOR_MAP } from './constants';
import useService from './useService';

type GetKeyConfigProps = {
	kycStatus: any;
};

export const getKeyConfig = ({ kycStatus }: GetKeyConfigProps) => {
	const { getKycDetails } = useService();
	const [css] = useStyletron();

	const kycStatusKeyConfig = {
		name: VIEW_FIELD_KEYS.KYC_STATUS,
		label: 'Kyc Status',
		override: {
			style: ({ keyData }: StyleOverrideFunctionPropsT) => {
				return {
					value: css({
						backgroundColor: _get(KYC_STATUS_VALUE_COLOR_MAP, keyData, GLOBAL_THEME.Colors.cellYellow)
					})
				};
			}
		}
	};

	const kycDetailsKeyConfig = [
		{
			name: VIEW_FIELD_KEYS.MANUAL_VERIFICATION_REQ,
			label: 'Manual Verification Required'
		},
		{
			name: VIEW_FIELD_KEYS.KYC_DETAILS,
			label: 'KYC Details',
			initiallyCollapsed: true,
			childConfig: [
				{
					name: VIEW_FIELD_KEYS.DATE_OF_BIRTH,
					label: 'Date of birth'
				},
				{
					name: VIEW_FIELD_KEYS.DOC_IMAGE,
					label: 'Document Image',
					override: {
						format: 'image'
					}
				},
				{
					name: VIEW_FIELD_KEYS.DOC_NUMBER,
					label: 'Document Number'
				},
				{
					name: VIEW_FIELD_KEYS.DOC_TYPE,
					label: 'Document Type'
				},
				{
					name: VIEW_FIELD_KEYS.REJECTION_MESSAGE,
					label: 'Rejection Message'
				},
				{
					name: VIEW_FIELD_KEYS.FULL_NAME,
					label: 'Full Name'
				},
				{
					name: VIEW_FIELD_KEYS.TIMESTAMP,
					label: 'Timestamp'
				},
				{
					name: VIEW_FIELD_KEYS.LAST_UPDATED_AT,
					label: 'Last Updated At'
				},
				{
					name: VIEW_FIELD_KEYS.UID,
					label: 'UID'
				},
				{
					name: VIEW_FIELD_KEYS.DEVICE_TYPE,
					label: 'Device Type'
				},
				{
					name: VIEW_FIELD_KEYS.OCR_RESULT,
					label: 'OCR Result',
					childConfig: [
						{
							name: VIEW_FIELD_KEYS.LAST_ID,
							label: 'Last Id'
						},
						{
							name: VIEW_FIELD_KEYS.MERCHANT,
							label: 'Merchant'
						},
						{
							name: VIEW_FIELD_KEYS.OCR_RESULT_STATUS,
							label: 'Status'
						},
						{
							name: VIEW_FIELD_KEYS.AGE,
							label: 'Age'
						},
						{
							name: VIEW_FIELD_KEYS.DOI,
							label: 'DOI'
						},
						{
							name: VIEW_FIELD_KEYS.FATHER_NAME,
							label: 'Father Name'
						},
						// {
						// 	name: VIEW_FIELD_KEYS.IS_SCANNED,
						// 	label: 'Is Scanned'
						// },
						{
							name: VIEW_FIELD_KEYS.MINOR,
							label: 'Minor'
						}
						// {
						// 	name: VIEW_FIELD_KEYS.SCAN_TYPE,
						// 	label: 'Scan type'
						// }
					]
				}
			]
		}
	];

	const childConfig: any[] = [kycStatusKeyConfig];
	const keyConfig = {
		childConfig,
		name: VIEW_FIELD_KEYS.KYC_DETAILS_SCREEN,
		fetchData: getKycDetails
	};

	switch (kycStatus) {
		case KYC_STATUS_VALUE.APPROVED:
		case KYC_STATUS_VALUE.REJECTED:
		case KYC_STATUS_VALUE.PENDING:
		case KYC_STATUS_VALUE.ERROR:
		case KYC_STATUS_VALUE.NAME_MISMATCH:
		case KYC_STATUS_VALUE.PROCESSING:
		case KYC_STATUS_VALUE.ALLOWED:
			keyConfig.childConfig = [...keyConfig.childConfig, ...kycDetailsKeyConfig];
			break;
		default:
			break;
	}

	return {
		keyConfig
	};
};
